import { render, staticRenderFns } from "./SelectYear.vue?vue&type=template&id=ffa0e56a&"
import script from "./SelectYear.vue?vue&type=script&lang=js&"
export * from "./SelectYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports